export default __webpack_public_path__ + "static/media/Background_00135.27eab1b7.png";